import { render } from "./EditTeams.vue?vue&type=template&id=1331ad8a&scoped=true"
import script from "./EditTeams.vue?vue&type=script&lang=js"
export * from "./EditTeams.vue?vue&type=script&lang=js"

import "./EditTeams.vue?vue&type=style&index=0&id=1331ad8a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Kuppen_front/Kuppen_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1331ad8a"]])

export default __exports__